<template>
  <b-modal
    id="JobPositionStatusModal"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
    :visible="showJobPosModal"
    @show="getPositionIDStatus"
    @hidden="$emit('close-pos-status-modal')"
  >
    <div class="cs-modal-header">
      <div>Job Position Status</div>
      <div
        @click="$emit('close-pos-status-modal')"
        class="rotate-on-hover pointer"
      >
        <img src="@/assets/panelist/blue_cross.svg" alt="" />
      </div>
    </div>

    <b-container class="jpm-body">
      <b-row class="jpm-table-header">
        <b-col cols="2" class="d-flex pl-5"
          >Position ID
          <img
            v-if="sortBy !== 'positionID'"
            class="pointer ml-2"
            src="@/assets/img/accessconnew/nosort.svg"
            alt
            @click="
              (sortBy = 'positionID'), (order = -1), getPositionIDStatus()
            "
          />
          <template v-if="sortBy === 'positionID'">
            <img
              v-show="order === 1"
              class="pointer ml-2"
              src="@/assets/img/accessconnew/ascSort.svg"
              alt
              @click="
                (sortBy = 'positionID'), (order = -1), getPositionIDStatus()
              "
            />
            <img
              v-show="order === -1"
              class="pointer ml-2"
              src="@/assets/img/accessconnew/descSort.svg"
              alt
              @click="
                (sortBy = 'positionID'), (order = 1), getPositionIDStatus()
              "
            />
          </template>
        </b-col>
        <b-col cols="3" class="d-flex pl-4">Recruiter Name </b-col>
        <b-col cols="2"
          >Status
          <img
            v-if="sortBy !== 'status'"
            class="pointer ml-2"
            src="@/assets/img/accessconnew/nosort.svg"
            alt
            @click="(sortBy = 'status'), (order = -1), getPositionIDStatus()"
          />
          <template v-if="sortBy === 'status'">
            <img
              v-show="order === 1"
              class="pointer ml-2"
              src="@/assets/img/accessconnew/ascSort.svg"
              alt
              @click="(sortBy = 'status'), (order = -1), getPositionIDStatus()"
            />
            <img
              v-show="order === -1"
              class="pointer ml-2"
              src="@/assets/img/accessconnew/descSort.svg"
              alt
              @click="(sortBy = 'status'), (order = 1), getPositionIDStatus()"
            />
          </template>
        </b-col>
        <b-col cols="3">Comments</b-col>
        <b-col cols="2">Action</b-col>
      </b-row>
      <div class="jpm-vertical-scroll">
        <b-skeleton-wrapper :loading="loaderStatus">
          <template #loading>
            <b-row v-for="(i, index) in 7" :key="index" class="mt-4 w-100">
              <b-col class="shimmer">
                <b-skeleton type="input"></b-skeleton>
              </b-col>
            </b-row>
          </template>
          <b-row
            v-for="(status, i) in statusData"
            :key="i"
            class="jpm-table-row"
          >
            <div
              :class="
                status.openCollapse
                  ? 'jpm-left-blue-border'
                  : 'jpm-left-blue-border-2'
              "
            ></div>
            <b-row class="w-100 m-0">
              <b-col cols="2" class="d-flex pl-5"
                >{{ status.positionID }}
              </b-col>
              <b-col cols="3" class="d-flex pl-4">
                <template v-if="!status.activeAssigned.length">
                  <div>-</div>
                </template>
                <template v-else>
                  <div
                    class="d-flex align-items-center position-relative"
                    :style="
                      status.activeAssigned.length > 3
                        ? 'width: 100px'
                        : status.activeAssigned.length == 3
                        ? 'width: 70px;'
                        : status.activeAssigned.length == 2
                        ? 'width: 45px;'
                        : status.activeAssigned.length == 1
                        ? 'width: 20px;'
                        : ''
                    "
                  >
                    <div
                      v-if="status.activeAssigned.length > 0"
                      class="roundDarkBlue"
                      style="left: 0px"
                      v-b-tooltip.hover.top="status.activeAssigned[0].username"
                    >
                      {{ status.activeAssigned[0].userIcon }}
                    </div>
                    <div
                      v-if="status.activeAssigned.length > 1"
                      class="roundDarkBlue"
                      style="left: 25px"
                      v-b-tooltip.hover.top="status.activeAssigned[1].username"
                    >
                      {{ status.activeAssigned[1].userIcon }}
                    </div>
                    <div
                      v-if="status.activeAssigned.length > 2"
                      class="roundDarkBlue"
                      style="left: 50px"
                      v-b-tooltip.hover.top="status.activeAssigned[2].username"
                    >
                      {{ status.activeAssigned[2].userIcon }}
                    </div>
                    <div
                      v-if="status.activeAssigned.length === 4"
                      class="roundDarkBlue"
                      style="left: 75px"
                      v-b-tooltip.hover.top="status.activeAssigned[3].username"
                    >
                      {{ status.activeAssigned[3].userIcon }}
                    </div>
                    <div
                      v-if="status.activeAssigned.length > 4"
                      class="roundLightBlue"
                      style="left: 75px"
                    >
                      {{ status.activeAssigned.length - 3 }}
                    </div>
                  </div>
                </template>
              </b-col>
              <b-col cols="2">
                <div class="relativeclass" style="width: 110px">
                  <div
                    v-closeArray="{
                      i,
                      property: 'openDropdown',
                      array: statusData,
                      handler: closeJobDropdown(i),
                      exclude: ['jobDropDown'],
                    }"
                    tabIndex="0"
                    class="
                      d-flex
                      align-items-center
                      justify-content-between
                      jobSelection-dropdown-div
                      px-3
                    "
                    :class="onHold ? 'disable-inputField' : ''"
                    :style="getAvatarStyle(status.status)"
                    @click="
                      !onHold
                        ? ((status.openDropdown = !status.openDropdown),
                          (currentStatus = status.status),
                          $forceUpdate())
                        : ''
                    "
                  >
                    <div class="mr-2">
                      {{ getStatusName(status.status) }}
                    </div>
                    <img
                      v-show="!status.openDropdown"
                      :src="getSourceDownArrow(status.status)"
                      alt=""
                    />
                    <img
                      v-show="status.openDropdown"
                      :src="getSourceUpArrow(status.status)"
                      alt=""
                    />
                  </div>
                  <div
                    v-if="status.openDropdown"
                    class="relativeclass jobDropDown"
                  >
                    <div class="newInt-radio-dropdown p-0">
                      <b-form-group class="sec-mcq-datacard">
                        <b-form-radio-group
                          class="newInt-radio-dropdown-inner-content w-100"
                          size="sm"
                          v-model="currentStatus"
                          :options="statusOptions"
                          @change="
                            (status.openDropdown = false), (currentIndex = i);
                            isCommentsModal = true;
                          "
                          :disabled="onHold"
                          buttons
                          stacked
                        >
                        </b-form-radio-group>
                      </b-form-group>
                    </div>
                  </div>
                </div>
              </b-col>
              <b-col
                cols="3"
                class="text-truncate"
                v-b-tooltip.hover.left="status.comments"
                >{{ status.comments === "" ? "-" : status.comments }}</b-col
              >
              <b-col @click="onActionClick(i)" cols="2" class="pl-4">
                <img
                  class="pointer"
                  v-if="!status.openCollapse"
                  src="@/assets/img/newcreatejob/preview.svg"
                  alt=""
                />
                <img
                  class="pointer"
                  v-if="status.openCollapse"
                  src="@/assets/img/newcreatejob/crossPreview.svg"
                  alt=""
                />
              </b-col>
            </b-row>
            <b-collapse v-model="status.openCollapse">
              <div class="jpm-horizontal-scroll mt-4">
                <div
                  v-for="(hist, index) in statusHistory"
                  :key="index"
                  class="jpm-vertical-flex"
                >
                  <div
                    v-if="index !== statusHistory.length - 1"
                    class="jpm-horizontal-bar"
                  ></div>
                  <span class="jpm-light-grey-txt"
                    >({{ hist.activityAt }})</span
                  >
                  <div>
                    <img
                      v-if="hist.description === 'Closed'"
                      src="@/assets/img/newcreatejob/greyCreated.svg"
                      alt=""
                    />
                    <img
                      v-if="hist.description === 'Active'"
                      src="@/assets/img/newcreatejob/greenClosed.svg"
                      alt=""
                    />
                    <img
                      v-if="
                        hist.description === 'Created' ||
                        hist.description === 'Assigned' ||
                        hist.description === 'Re-assigned'
                      "
                      src="@/assets/img/newcreatejob/blueAssigned.svg"
                      alt=""
                    />
                    <img
                      v-if="hist.description === 'On-Hold'"
                      src="@/assets/img/newcreatejob/yellow-on-hold.svg"
                      alt=""
                    />
                    <img
                      v-if="hist.description === 'Cancelled'"
                      src="@/assets/img/newcreatejob/orangeCancelled.svg"
                      alt=""
                    />
                    <img
                      v-if="hist.description === 'Lost'"
                      src="@/assets/img/newcreatejob/redLost.svg"
                      alt=""
                    />
                  </div>
                  <div class="text-center">
                    <div
                      class="jpm-scroll-txt"
                      :class="historyDescriptionClass(hist.description)"
                    >
                      {{
                        !hist.statusChange
                          ? hist.description
                          : "Status Changed: " + hist.description
                      }}
                    </div>
                    <div class="d-flex px-3 align-items-center mt-1">
                      <span
                        v-if="hist.statusChange"
                        class="jpm-light-grey-txt-2"
                        >By:&nbsp;</span
                      >
                      <span v-if="hist.statusChange" class="jpm-black-txt"
                        >{{ hist.userID.username }}
                      </span>
                      <div
                        v-show="
                          hist.description === 'Assigned' ||
                          hist.description === 'Re-assigned'
                        "
                        class="d-flex flex-column"
                      >
                        <span
                          v-for="(name, idx) in hist.assignedTo
                            ? hist.assignedTo.slice(-2)
                            : []"
                          :key="idx"
                          class="jpm-black-txt"
                        >
                          {{ name.username }}
                        </span>
                      </div>
                    </div>
                    <div
                      v-show="
                        (hist.description === 'Assigned' ||
                          hist.description === 'Re-assigned') &&
                        hist.assignedTo.length > 2
                      "
                      class="jpm-show-more"
                    >
                      <span
                        v-b-tooltip.right="
                          hist.assignedTo
                            ? hist.assignedTo
                                .map((name) => name.username)
                                .join(', ')
                            : ''
                        "
                      >
                        Show More
                      </span>
                    </div>
                    <div v-show="hist.comments" class="jpm-show-more">
                      <span
                        v-b-tooltip.right="hist.comments"
                        @mouseenter="
                          (hist.comment = 'Hide Comment'), $forceUpdate()
                        "
                        @mouseleave="
                          (hist.comment = 'View Comment'), $forceUpdate()
                        "
                      >
                        {{ hist.comment }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </b-collapse>
          </b-row>
        </b-skeleton-wrapper>
      </div>
    </b-container>
    <div
      class="
        pff-footer-container
        d-flex
        align-items-center
        justify-content-end
        px-3
        pb-3
        newoutline
      "
    >
      <b-button
        variant="padding-4-21 outline-primary"
        @click="$emit('close-pos-status-modal')"
        >Close</b-button
      >
    </div>
    <CommentsModal
      v-if="isCommentsModal"
      :isCommentsModal="isCommentsModal"
      :buttonLoader="buttonLoader"
      @save-comment="onSaveComment"
      @close-modal="isCommentsModal = false"
    />
  </b-modal>
</template>

<script>
import {
  getPositionIDStatus,
  changePositionIDStatus,
} from "@/utils/apiFunctions";
import CommentsModal from "./CommentsModal.vue";
import {
  getAvatarStyle,
  getStatusName,
  getSourceDownArrow,
  getSourceUpArrow,
} from "@/controllers/commonHelpers";

export default {
  data() {
    return {
      sortBy: "positionID",
      order: 1,
      currentStatus: null,
      currentIndex: null,
      isCommentsModal: false,
      loaderStatus: false,
      buttonLoader: false,
      statusData: [],
      statusHistory: [],
      statusOptions: [
        { text: "Lost", value: 4 },
        { text: "Closed", value: 3 },
        { text: "On-Hold", value: 2 },
        { text: "Active", value: 1 },
        { text: "Cancelled", value: 0 },
      ],
    };
  },
  props: {
    showJobPosModal: Boolean,
    onHold: Boolean,
  },
  components: {
    CommentsModal,
  },
  methods: {
    closeJobDropdown(index) {
      return () => {
        this.statusData[index].openDropdown = false;
        this.$forceUpdate();
      };
    },
    getAvatarStyle(status) {
      return getAvatarStyle(status);
    },
    getSourceDownArrow(status) {
      return getSourceDownArrow(status);
    },
    getSourceUpArrow(status) {
      return getSourceUpArrow(status);
    },
    async getPositionIDStatus() {
      try {
        this.loaderStatus = true;
        let payload = {
          jobID: this.$route.query.jobID,
          sortBy: this.sortBy,
          order: this.order,
        };
        let res = await getPositionIDStatus(payload);
        if (res.status === 200) {
          this.statusData = res.data.data.data;
          this.statusData.forEach((status) => {
            status.openDropdown = false;
          });
          this.setUserIcon();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loaderStatus = false;
      }
    },
    async onSaveComment(comment) {
      try {
        this.buttonLoader = true;
        let payload = {
          jobID: this.$route.query.jobID,
          positionID: this.statusData[this.currentIndex].positionID,
          status: this.currentStatus,
          comments: comment,
        };
        let res = await changePositionIDStatus(payload);
        if (res.status === 200) {
          this.getPositionIDStatus();
          this.isCommentsModal = false;
          this.buttonLoader = false;
        }
      } catch (error) {
        console.error(error);
      }
    },
    onActionClick(i) {
      this.statusData.forEach((status, idx) => {
        idx === i
          ? (status.openCollapse = !status.openCollapse)
          : (status.openCollapse = false);
      });
      this.$forceUpdate();
      if (this.statusData[i].openCollapse) {
        this.positionIDHistory(i);
      }
    },
    async positionIDHistory(i) {
      try {
        let payload = {
          jobID: this.$route.query.jobID,
          positionID: this.statusData[i].positionID,
        };
        let res = await getPositionIDStatus(payload);
        if (res.status === 200) {
          this.statusHistory = res.data.data.activity;
          this.statusHistory.forEach((hist) => (hist.comment = "View Comment"));
        }
      } catch (error) {
        console.error(error);
      }
    },
    historyDescriptionClass(description) {
      let className;
      switch (description) {
        case "Closed":
          className = "jpm-grey-text";
          break;
        case "Created":
          className = "jpm-blue-txt";
          break;
        case "Assigned":
          className = "jpm-blue-txt";
          break;
        case "Re-assigned":
          className = "jpm-blue-txt";
          break;
        case "On-Hold":
          className = "jpm-yellow-txt";
          break;
        case "Active":
          className = "jpm-green-txt";
          break;
        case "Cancelled":
          className = "jpm-orange-txt";
          break;
        case "Lost":
          className = "jpm-red-txt";
          break;
      }
      return className;
    },
    setUserIcon() {
      for (let i in this.statusData) {
        for (let j in this.statusData[i].activeAssigned) {
          if (this.statusData[i].activeAssigned[j].username.includes(" ")) {
            const first = this.statusData[i].activeAssigned[j].username
              .split(" ")[0][0]
              .toUpperCase();
            const sec = this.statusData[i].activeAssigned[j].username
              .split(" ")[1][0]
              .toUpperCase();
            this.statusData[i].activeAssigned[j].userIcon = first + sec;
          } else {
            const value = this.statusData[i].activeAssigned[j].username
              .slice(0, 2)
              .toUpperCase();
            this.statusData[i].activeAssigned[j].userIcon = value;
          }
        }
        this.statusData[i].openCollapse = false;
      }
    },
    getStatusName(status) {
      return getStatusName(status);
    },
  },
};
</script>

<style>
#JobPositionStatusModal .modal-body {
  padding: 0;
}

#JobPositionStatusModal .modal-dialog {
  max-width: 1000px !important;
}

.jpm-body {
  padding: 15px;
}

.jpm-table-header {
  background-color: #e9f0f5;
  font-family: "Lato", sans-serif;
  font-size: var(--size-14);
  font-weight: var(--weight-M);
  color: var(--bluetheme);
  margin: 0;
  padding: 10px 0;
}

.jpm-table-row {
  margin: 10px 0;
  box-shadow: 0px 4px 15px 0px #c4c4c480;
  background-color: #fcfcfc;
  border-radius: 5px;
  position: relative;
  font-family: "Lato", sans-serif;
  font-size: var(--size-15);
  font-weight: var(--weight-R);
  color: var(--bluetheme);
  padding: 12px 0;
}

.jpm-left-blue-border {
  height: 94%;
  width: 3px;
  border-radius: 4px;
  background-color: var(--bluetheme);
  position: absolute;
  top: 5px;
  left: 3px;
}

.jpm-left-blue-border-2 {
  height: 78%;
  width: 3px;
  border-radius: 4px;
  background-color: var(--bluetheme);
  position: absolute;
  top: 5px;
  left: 3px;
}

.jpm-vertical-flex {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 162px;
  flex-shrink: 0;
  margin: 0 15px;
  position: relative;
}

.jpm-horizontal-scroll {
  display: flex;
  width: 935px;
  overflow-x: auto;
  margin-left: 15px;
}

.jpm-horizontal-scroll::-webkit-scrollbar {
  scroll-behavior: smooth;
  width: 0px !important;
  height: 0px !important;
  background-color: transparent !important;
}

.jpm-horizontal-bar {
  position: absolute;
  background: #bdcdda80;
  border-radius: 8px;
  height: 5px;
  width: 136px;
  top: 33px;
  left: 109px;
}

.jpm-vertical-scroll {
  height: 400px;
  overflow: auto;
}

.jpm-light-grey-txt {
  font-family: "Lato", sans-serif;
  font-size: var(--size-11);
  font-style: italic;
  font-weight: var(--weight-LM);
  color: #8c8c8c80;
}

.jpm-light-grey-txt-2 {
  font-family: "Montserrat", sans-serif;
  font-size: var(--size-12);
  font-style: italic;
  font-weight: var(--weight-M);
  color: #8c8c8c;
}

.jpm-black-txt {
  font-family: "Montserrat", sans-serif;
  font-size: var(--size-12);
  font-weight: var(--weight-M);
  line-height: 14.63px;
  text-align: center;
  color: var(--cv-grey);
}

.jpm-scroll-txt {
  font-family: "Montserrat", sans-serif;
  font-size: var(--size-12);
  font-style: italic;
  font-weight: var(--weight-M);
}

.jpm-blue-txt {
  color: var(--bluetheme);
}

.jpm-green-txt {
  color: #038e00;
}

.jpm-orange-txt {
  color: #b05500;
}

.jpm-red-txt {
  color: #b00101;
}

.jpm-yellow-txt {
  color: #e4b320;
}

.jpm-grey-text {
  color: #6c757d;
}

.jpm-show-more {
  font-family: "Lato", sans-serif;
  font-size: var(--size-12);
  font-weight: var(--weight-M);
  text-decoration: underline;
  cursor: default;
}
</style>
